import { Flex, CardHeader, Text, CardProps } from "@chakra-ui/react";

import { CardBody } from "@chakra-ui/react";

import { Card } from "@chakra-ui/react";

interface NoDataAvailableProps extends CardProps {
	title: string;
}

export function NoDataAvailable({ title, ...props }: NoDataAvailableProps) {
	return (
		<Card borderRadius={"15px"} h="100%" {...props}>
			<CardHeader>
				<Flex
					direction="row"
					justifyContent={"space-between"}
					alignItems={"center"}
				>
					<Text color="gray.1000" fontSize="17px" fontWeight="600">
						{title}
					</Text>
				</Flex>
			</CardHeader>
			<CardBody>
				<Flex justifyContent={"center"} alignItems={"center"} h="100%">
					<Text>No data available</Text>
				</Flex>
			</CardBody>
		</Card>
	);
}
